import { Skeleton } from "@/components/ui/skeleton";

export function HistorySkeleton() {
  return (
    <div aria-hidden className="flex h-full">
      <div className="hidden w-64 shrink-0 flex-col gap-1.5 border-r p-3 md:flex">
        <Skeleton className="h-14 rounded-lg" />
        <Skeleton className="h-14 rounded-lg" />
        <Skeleton className="h-14 rounded-lg" />
        <Skeleton className="h-14 rounded-lg" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="mx-auto flex max-w-2xl flex-col gap-4 px-4 pt-6 pb-10">
          <Skeleton className="h-12 w-3/5 self-end rounded-2xl" />
          <Skeleton className="h-20 w-2/3 self-start rounded-2xl" />
          <Skeleton className="h-10 w-1/2 self-end rounded-2xl" />
          <Skeleton className="h-16 w-2/3 self-start rounded-2xl" />
        </div>
      </div>
    </div>
  );
}
